import req from 'shared/req';
import {getEducator} from 'shared/actions/educator';
import {stopLoading} from 'shared/actions/loading';
import {
  RECEIVE_EDUCATOR,
  EDUCATOR_VERIFIED,
  EDUCATOR_EMAIL_CONFIRMED,
} from '../action-types/educator';
import {closeEmailConfirmationModal} from './email-confirmation';

const EDUCATOR_FIELDS = [
  '_id',
  'type',
  'title',
  'firstName',
  'lastName',
  'email',
  'mobile',
  'demoStudentId',
  'featureFlags',
  'isVerified',
  'emailVerifiedAt',
  'eligibleForVerificationAt',
  'inboundConfirmationCode',
  'isRejected',
  'institution',
  'linkedinConnected',
  'officialIdPath',
  'cleverId',
  'displayNameToStudent',
  'joinUrl',
  'connectedCourses',
].join();

export const DASHBOARD_STATS_LOADING_IDENTIFIER = 'dashboardStats';

export const fetchEducator = () => (dispatch) =>
  getEducator('me', EDUCATOR_FIELDS).then((educator) => {
    dispatch({
      type: RECEIVE_EDUCATOR,
      payload: educator,
    });

    return educator;
  });

export const fetchDashboardStats = () => (dispatch) =>
  getEducator('me', 'dashboardStats').then((educator) => {
    dispatch({
      type: RECEIVE_EDUCATOR,
      payload: educator,
    });
    dispatch(stopLoading(DASHBOARD_STATS_LOADING_IDENTIFIER));
  });

const educatorVerified = () => ({
  type: EDUCATOR_VERIFIED,
});

export const educatorEmailConfirmed = () => ({
  type: EDUCATOR_EMAIL_CONFIRMED,
});

export const pollEducatorVerification = () => (dispatch) => {
  const second = 1000;
  const maxRetries = 50;
  const maxTimeout = 5 * 60 * second;
  const initialDelay = 10 * second;

  let retries = 0;

  const retryTimeout = () => {
    const timeout = second * Math.pow(1.5, retries);
    const jitter = Math.random() * 2 * second - second;
    return Math.min(Math.max(second, timeout + jitter), maxTimeout);
  };

  const getStatus = () =>
    req({
      url: '/v1/analytics-data/me',
      method: 'get',
    }).then(({userTraits: {status}}) => {
      if (status === 'pending') {
        dispatch(closeEmailConfirmationModal());
      } else if (status === 'verified') {
        dispatch(educatorVerified());
      } else {
        retries += 1;
        if (retries <= maxRetries) {
          window.setTimeout(getStatus, retryTimeout());
        }
      }
    });

  window.setTimeout(getStatus, initialDelay);
};
